import { appDependencies } from "../AppDependencies";
import { ICalendar } from "../calendars/ICalendar";
import { IEmployeeGroupAbsences } from "../employeeGroups/IEmployeeGroupAbsences";
import { IUserInfo } from "../users/IUserInfo";
import { IEmployeeService } from "./IEmployeeService";

export class EmployeeService implements IEmployeeService {
    async getEmployeeAbsenceInfos(): Promise<ICalendar[]> {
        return await appDependencies.IEmployeeRepository.getEmployeeAbsenceInfos();
    }
    async getAllCalendars(): Promise<ICalendar[]> {
        return await appDependencies.IEmployeeRepository.getAllCalendars();
    }
    async getEmployeeGroupAbsences(): Promise<IEmployeeGroupAbsences[]> {
        return await appDependencies.IEmployeeRepository.getEmployeeGroupAbsences();
    }

    async getAbsencesForAbsentPresentOverview(): Promise<IEmployeeGroupAbsences[]> {
        return await appDependencies.IEmployeeRepository.getAbsencesForAbsentPresentOverview();
    }

    async getUserInfo(): Promise<IUserInfo> {
        return appDependencies.IEmployeeRepository.getUserInfo();
    }
}
